import { NavbarLinkModel } from "./types";

export function isActiveLink(url: string, link: NavbarLinkModel): boolean {
  return url === link.href.replace("/", "");
}
